import { Injectable, Inject, LOCALE_ID } from '@angular/core';
import { APP_LANGUAGES } from '@shared/tokens/app-languages';

export class Language {
    public code: string;
    public name: string;
    public flag: string;

    public getLangUrl(pagePath: string): string {
      return `/${this.code}/${pagePath}`;
    }

    constructor(code: string, name: string, flag?: string) {
      this.code = code;
      this.name = name;
      this.flag = flag || code;
    }
}

class Languages {
    private _map: Map<string, Language>;

    constructor() {
        this._map = new Map();
    }
    get Languages(): Language[] {
        return Array.from(this._map.values());
    }
    set Languages(languages: Language[]) {
      for (const language of languages) {
        this._map.set(language.code, language);
      }
    }
    get LanguagesCode(): string[] {
        return Array.from(this._map.keys());
    }
    get default(): string {
        return this._map.keys().next().value;
    }

    getByCode(code: string): Language {
        return this._map.get(code);
    }

}

@Injectable({ providedIn: 'root'})
export class LanguagesService {
    private _languagesMap: Languages;
    constructor(@Inject(LOCALE_ID) private locale: string,
                @Inject(APP_LANGUAGES) private appLanguages: Language[]) {
        this._languagesMap = new Languages();
        this._languagesMap.Languages = this.appLanguages;
    }

    public getLanguages(): Language[] {
        return this._languagesMap.Languages;
    }
    public getLanguageByCode(code): Language{
        return this._languagesMap.getByCode(code);
    }
    public getCurrentLang(): Language {
        return this._languagesMap.getByCode(this.locale.substring(0, 2));
    }

    public getCurrentLangCode(): string {
      return this.locale.substring(0, 2);
  }
}
